import {
  WbHeaderActionButton,
  WittyChat,
  WittyIcon,
} from '@agilelab/plugin-wb-platform';
import { Dialog, makeStyles, useMediaQuery, useTheme } from '@material-ui/core';
import { useEffect } from 'react';
import { useWittyAssistant } from '../../contexts/useWittyAssistant';
import { useWittyAssistantEnabled } from '../../hooks/useWittyAssistantEnabled';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  expandingChat: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
    justifySelf: 'flex-end',
    height: '100vh',
    width: '40vw',
  },
  expandedChat: {
    position: 'absolute',
    top: 0,
    right: 0,
    justifySelf: 'flex-end',
    zIndex: 1,
    height: '100vh',
    width: '70vw',
  },
}));

export const WittyAssistant = () => {
  const classes = useStyles();
  const { enabled, loading: loadingEnabled } = useWittyAssistantEnabled();
  const mobile = useMediaQuery(useTheme().breakpoints.down('xs'));

  const {
    loading,
    statusText,
    messages,
    open,
    onNewMessage,
    setOpen,
    expanded,
    setExpanded,
    onNewSession,
    historyOpen,
    setHistoryOpen,
    sessions,
    sessionsLoading,
    loadSessions,
    loadMoreSessions,
    hasMoreSessions,
    searchSessions,
    sessionSearchQuery,
    onSelectSession,
    onRenameSession,
    onDeleteSession,
    activeSessionId,
  } = useWittyAssistant();

  useEffect(() => {
    if (!enabled && open) {
      setOpen(false);
      setExpanded(false);
    }
  }, [enabled, open, setExpanded, setOpen]);

  if (loadingEnabled || !enabled) {
    return null;
  }

  const chatContent = (
    <WittyChat
      mobile={mobile}
      incomingMessage={loading}
      statusText={statusText}
      messages={messages}
      onNewMessage={onNewMessage}
      onNewSession={onNewSession}
      setOpen={setOpen}
      setChatExpanded={() =>
        setExpanded((prevExpanded: boolean) => !prevExpanded)
      }
      isMicrophoneActive={false}
      isAttachContentActive={false}
      isFeedbackActive={false}
      historyOpen={historyOpen}
      setHistoryOpen={setHistoryOpen}
      sessions={sessions}
      sessionsLoading={sessionsLoading}
      loadSessions={loadSessions}
      loadMoreSessions={loadMoreSessions}
      hasMoreSessions={hasMoreSessions}
      searchSessions={searchSessions}
      sessionSearchQuery={sessionSearchQuery}
      onSelectSession={onSelectSession}
      onRenameSession={onRenameSession}
      onDeleteSession={onDeleteSession}
      activeSessionId={activeSessionId}
    />
  );

  const trigger = (
    <WbHeaderActionButton
      icon={<WittyIcon />}
      label="Ask Witty"
      aria-label="Open Witty Chat"
      onClick={() => {
        setExpanded(false);
        setOpen(true);
      }}
    />
  );

  if (mobile)
    return (
      <>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullScreen
          aria-label="Witty Chat"
        >
          {chatContent}
        </Dialog>
        {trigger}
      </>
    );

  return open ? (
    <div
      className={clsx(expanded ? classes.expandedChat : classes.expandingChat)}
    >
      {chatContent}
    </div>
  ) : (
    trigger
  );
};
